<app-traitement-data titre="Fréquence" [sousTitre]="patient!.tableauDeBord?.frequence?.date | aLaDateDu">
    {{ (patient!.tableauDeBord?.frequence?.value) ?? 'Pas de donnée' }}
</app-traitement-data>